module.exports = __webpack_public_path__ + "static/media/gu.243ab68e.svg";